<template>
  <div>
    <b-form-group class="form-group-radio-group " :class="form_group_class" :label="field_label"
      :label-class="label_class + ' text-left mb-0'" :field_model="field_model">
      <template slot="label"><div v-html="field_label"></div></template>
      <p v-if="is_invalid" :class="error_message_class">
        {{ invalid_message }}
      </p>
      <b-form-radio-group id="field_model" v-model="_field_model" :name="name">
        <b-form-radio v-for="option in options" :key="option.value" class="
              form-control 
              radio-input-container
              mb-1
            " :class="form_control_class" v-model="_field_model" :name="name" :value="option.value">{{ option.label
            }}</b-form-radio>
      </b-form-radio-group>
    </b-form-group>
  </div>
</template>


<script>
export default {
  name: "InputRadio",
  components: {},
  props: ["field_label", "field_model", "options",
    "name", "is_invalid", "invalid_message"],
  props: {
    type: {
      type: String,
    },
    field_label: {
      type: String,
    },
    field_model: {
      type: String,
    },
    options: {
      type: Array,
    },
    name: {
      type: String,
    },
    is_invalid: {
      type: Boolean,
    },
    invalid_message: {
      type: String,
    },
    form_group_class: {
      type: String,
      default: "form-group-radio-garden-help"
    },
    label_class: {
      type: String,
      default: "form-label-garden-help"
    },
    form_control_class: {
      type: String,
      default: "form-control-garden-help"
    },
    error_message_class:{
      type: String,
      default: "error_validation_message_p_gardenhelp"
    }
  },
  data() {
    return {};
  },
  mounted() {
    // console.log(this.field_label);
    // console.log(this.field_model);
    // console.log(this.options);
  },

  computed: {
    _field_model: {
      get() {
        return ''+this.field_model;
      },
      set(value) {
        this.$emit("update:field_model", ''+value);
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Inputs/InputRadio.vue